export interface IRsvpForm {
  confirmArrival: string;
  arrivalText: string;
}

export class RsvpFormClass implements IRsvpForm {
  confirmArrival: string;
  arrivalText: string;

  constructor(rsvpForm?: Partial<IRsvpForm>) {
    this.confirmArrival = rsvpForm?.confirmArrival ?? '';
    this.arrivalText = rsvpForm?.arrivalText ?? '';
  }
}
